export const MiscellaneousKeys = {
	all: ["miscellaneous"] as const,
	appColor: () => [...MiscellaneousKeys.all, "appColor"] as const,
};
